/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
     ========================================================================== */

/**
   * Remove the margin in all browsers.
   */

body {
  margin: 0;
}

/**
   * Render the `main` element consistently in IE.
   */

main {
  display: block;
}

/**
   * Correct the font size and margin on `h1` elements within `section` and
   * `article` contexts in Chrome, Firefox, and Safari.
   */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
     ========================================================================== */

/**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd `em` font sizing in all browsers.
   */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
     ========================================================================== */

/**
   * Remove the gray background on active links in IE 10.
   */

a {
  background-color: transparent;
}

/**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}

/**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */

b,
strong {
  font-weight: bolder;
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd `em` font sizing in all browsers.
   */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
   * Add the correct font size in all browsers.
   */

small {
  font-size: 80%;
}

/**
   * Prevent `sub` and `sup` elements from affecting the line height in
   * all browsers.
   */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
     ========================================================================== */

/**
   * Remove the border on images inside links in IE 10.
   */

img {
  border-style: none;
}

/* Forms
     ========================================================================== */

/**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */

button,
input {
  /* 1 */
  overflow: visible;
}

/**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */

button,
select {
  /* 1 */
  text-transform: none;
}

/**
   * Correct the inability to style clickable types in iOS and Safari.
   */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
   * Remove the inner border and padding in Firefox.
   */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
   * Restore the focus styles unset by the previous rule.
   */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
   * Correct the padding in Firefox.
   */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from `fieldset` elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    `fieldset` elements in all browsers.
   */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */

progress {
  vertical-align: baseline;
}

/**
   * Remove the default vertical scrollbar in IE 10+.
   */

textarea {
  overflow: auto;
}

/**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
   * Remove the inner padding in Chrome and Safari on macOS.
   */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to `inherit` in Safari.
   */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
     ========================================================================== */

/*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */

details {
  display: block;
}

/*
   * Add the correct display in all browsers.
   */

summary {
  display: list-item;
}

/* Misc
     ========================================================================== */

/**
   * Add the correct display in IE 10+.
   */

template {
  display: none;
}

/**
   * Add the correct display in IE 10.
   */

[hidden] {
  display: none;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-style: inherit;
  vertical-align: baseline;
}


/**
 * @prop --ic-z-index-menu: z-index of search bar menu
 */

:host(.ic-search-bar-search) {
  display: block;

  --divider-height: 1.5rem;
  --ic-input-label-helpertext-padding: var(--ic-space-xs);
  --border-color: var(--ic-search-bar-outline);
  --input-bg-color: var(--ic-search-bar-background);
  --border-color-disabled: var(--ic-search-bar-outline-disabled);
  --menu-item-text-color: var(--ic-search-bar-dropdown-option-text);
  --menu-item-desc-text-color: var(--ic-search-bar-dropdown-option-description);
  --menu-bg-color: var(--ic-search-bar-dropdown-background);
  --menu-border-color: var(--ic-search-bar-dropdown-outline);
}

:host(.ic-search-bar-disabled) {
  --ic-input-label-text-color: var(--ic-search-bar-label-disabled);
  --ic-input-label-helper-text-color: var(--ic-search-bar-subtitle-disabled);
}

:host(.ic-search-bar-search:hover) {
  --border-color: var(--ic-search-bar-outline-hover);
}

:host(.ic-search-bar-search:active) {
  --border-color: var(--ic-search-bar-outline-pressed);
}

:host(.ic-search-bar-search.ic-search-bar-small) {
  --divider-height: 1rem;
}

:host(.ic-search-bar-full-width) {
  width: 100%;
}

/* Custom Input */

::-moz-placeholder {
  color: var(--ic-search-bar-placeholder-text);
  opacity: 1;
}

::placeholder {
  color: var(--ic-search-bar-placeholder-text);
  opacity: 1;
}

input {
  border: 0;
  border-radius: var(--ic-border-radius);
  color: var(--ic-search-bar-filled-text);
  background-color: var(--input-bg-color);
  line-height: 1.5rem;
  letter-spacing: 0.005rem;
  width: 100%;
  padding-right: var(--ic-space-xs);
  padding-left: var(--ic-space-xs);
  caret-color: var(--ic-search-bar-filled-text-cursor);
}

input:focus {
  border: 0;
  outline: 0;
}

input:disabled::-moz-placeholder {
  color: var(--ic-search-bar-disabled-text);
}

input:disabled,
input:disabled::placeholder {
  color: var(--ic-search-bar-disabled-text);
}

/* Chrome, Safari, Edge */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-left-pad {
  padding-left: 0;
}

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}

input[type="search"].truncate-value {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* CLEAR */

.clear-button-container {
  align-items: center;
  margin-right: var(--ic-space-1px);
  display: none;
  visibility: hidden;
}

.clear-button {
  border-radius: var(--ic-border-radius);
  transition: box-shadow var(--ic-easing-transition),
    border-radius var(--ic-easing-transition);
}

.clear-button:focus,
.clear-button:active {
  background-color: var(--ic-color-focus-inner);
  box-shadow: inset 0 0 0 0.125rem var(--ic-color-focus-outer);
  border-radius: 0.25rem;
}

.clear-button-unfocused * {
  fill: var(--ic-search-bar-clear-button);
}

.clear-button:focus,
.clear-button:active * {
  fill: var(--ic-atoms-input-clear-button-focus);
}

.clear-button-visible {
  visibility: visible;
  display: flex;
}

.search-submit-button-container {
  display: flex;
  align-items: center;
}

.search-submit-button-unfocused * {
  fill: var(--ic-search-bar-filled-icon);
}

.search-submit-button-disabled * {
  fill: var(--ic-search-bar-icon-disabled);
}

.search-submit-button-disabled .ic-tooltip-container {
  display: none !important;
}

.search-submit-button:focus,
.search-submit-button:active {
  background-color: var(--ic-color-focus-inner) !important;
  box-shadow: inset 0 0 0 0.125rem var(--ic-color-focus-outer) !important;
  border-radius: var(--ic-space-xxs);
}

.search-submit-button:focus,
.search-submit-button:active * {
  fill: white;
}

.divider {
  width: var(--ic-border-width);
  background-color: var(--ic-search-bar-dropdown-divider);
  height: var(--divider-height);
}

.menu-container {
  width: var(--input-width, 20rem);
  position: relative;
  top: var(--ic-space-xxxs);
}

.menu-container.fullwidth {
  width: 100%;
}

.no-results {
  cursor: not-allowed;
}

.search-results-status {
  border: 0;
  clip: rect(0, 0, 0, 0, 0);
  height: var(--ic-space-1px);
  margin-bottom: calc(-1 * var(--ic-space-1px));
  margin-right: calc(-1 * var(--ic-space-1px));
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: var(--ic-space-1px);
}

@media (forced-colors: active) {
  .search-submit-button-unfocused * {
    fill: canvastext;
  }

  .search-submit-button-disabled * {
    fill: GrayText;
  }
}

/* Breakpoint value chosen as it's a small amount bigger than the search bar's default width */
@media screen AND (max-width: 22rem) {
  .menu-container {
    max-width: var(--menu-width, var(--input-width, 20rem));
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .clear-button {
    transition: none;
  }
}
